import type { CapiPlp } from 'types/capi/plp';

import gtm from '~/services/gtm.client';
import tiktok from '~/services/tiktok.pixel';
import twitter from '~/services/twitter.pixel';

import type { User } from '../../types/User';
import UserEvent from './UserEvent';

type EventData = {
  clientIp: string | null;
  isBot: boolean;
  plp: CapiPlp;
  user: User;
};

class PlpViewEvent extends UserEvent<EventData> {
  private getProductIds() {
    return this.data.plp.products.map((product) => product.id);
  }

  sendToTikTok() {
    return tiktok.fireEvent('ViewContent', {
      content_ids: this.getProductIds(),
      content_type: 'product'
    });
  }

  sendToTwitter() {
    return twitter.fireEvent(twitter.EventIds.ViewContent, {
      contents: this.getProductIds().map((productId) => ({
        content_id: productId,
        content_type: 'product'
      }))
    });
  }

  sendToGtm() {
    return gtm.Ecommerce.viewListItems(
      this.data.plp.products,
      this.data.plp.path_root
    );
  }

  collectServerEvents() {
    const is_sorted = this.data.plp.path_root.includes('sort=');

    this.serverEvents.push({
      data: { is_sorted, url: this.data.plp.canonical_url },
      type: 'plp_viewed'
    });
  }
}

export default PlpViewEvent;
